import { $, _hasParent } from "../util/DOM";

const initMenuButtons = () => {
  const menuIcons = $('.menu-icon');

  menuIcons.forEach((btn) => btn.addEventListener('click', function (e) {
    e.preventDefault();
    this.classList.toggle('hover');
  }));

  document.body.addEventListener('click', function (e) {
    menuIcons.forEach((btn) => {
      const isTarget = (el) => e.target === el || _hasParent(e.target, el);
      const menuContainer = btn.parentElement.querySelector('.trigger');
      if (isTarget(btn) || isTarget(menuContainer)) return;
      btn.classList.remove('hover');
    });
  }, false);
}

export default initMenuButtons;
